import { createContext } from 'react';

export const NamedRouteContext = createContext({});
